import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ToastrConfigs } from "../../../@core/data/toastr-config";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SupportTicketsService, SupportTicketStatusObject, SupportTicketTypeObject, SupportTicketUrgencyObject } from '../../../@core/data/support-tickets/supportTickets.service';
import * as moment from 'moment';
import { getTeams } from '../../../store/teams/teams.selectors';
const _ = require('lodash');
import { Store } from "@ngrx/store";
import { IAppState } from '../../../store/app.state';
import { getLoggedUser } from '../../../store/users/users.selectors';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { WorksheetService } from '../../../@core/data/worksheets/worksheet.service';

@Component({
  selector: 'ngx-add-edit-ticket-modal',
  templateUrl: 'add-edit-ticket-modal.component.html',
  styleUrls: ['add-edit-ticket-modal.component.scss'],
})
export class AddEditTicketModalComponent implements OnInit {
  @Input() ticket: any;
  public ticketDate = null;

  public form: FormGroup;
  
  public supportTicketUrgencyObject;
  public supportTicketUrgencyKeys;
  public supportTicketTypeObject;
  public supportTicketTypeKeys;
  public supportTicketStatusObject;
  public supportTicketStatusKeys;
  subject = new Subject<void>();
  public teams = [];
  loggedUser;
  @Input() clients: any[] = [];
  public selectedClient: string | null = null;

  constructor(
    protected ref: NbDialogRef<AddEditTicketModalComponent>,
    private supportTicketsService: SupportTicketsService,
    private toastrService: NbToastrService,
    private fb: FormBuilder,
    private store: Store<IAppState>,
    private worksheetService: WorksheetService,
  ) {
    this.supportTicketUrgencyObject = SupportTicketUrgencyObject();
    this.supportTicketUrgencyKeys = Object.keys(this.supportTicketUrgencyObject).map((key)=>Number(key));
    this.supportTicketTypeObject = SupportTicketTypeObject();
    this.supportTicketTypeKeys = Object.keys(this.supportTicketTypeObject).map((key)=>Number(key));
    this.supportTicketStatusObject = SupportTicketStatusObject();
    this.supportTicketStatusKeys = Object.keys(this.supportTicketStatusObject).map((key)=>Number(key));
  }

  ngOnInit() {
    this.store.select(getLoggedUser).pipe(takeUntil(this.subject)).subscribe((user)=>{
      if (!user?.user_id) return;
      this.loggedUser = user;
    })
    this.getItTeams();
    this.initForm();
    if (this.ticket?.clientName) {
      const found = this.clients.find(c => c.name === this.ticket.clientName);
      this.selectedClient = found ? found.id : null;
      if (found) {
        this.form.get('clientId').setValue(found.id);
      }
    }
    this.ticketDate = this.ticket?.date ? moment(parseFloat(this.ticket?.date)).subtract(1, 'day').toDate() : moment().subtract(1, "day").toDate();
  }

  getItTeams(){
    this.store.select(getTeams).subscribe((teams)=>{
      this.teams = teams.filter((team) => team.isIt === '1');
    })
  }

  ngOnDestroy () {
    this.subject.next();
  }

  initForm(){
    const hasDeadline = this.ticket?.deadline && this.ticket.deadline !== '' && this.ticket.deadline !== '0';
    this.form = this.fb.group({
      id: new FormControl(this.ticket?.id || null),
      title: new FormControl(this.ticket?.title || '', [Validators.required, Validators.maxLength(100)]),
      description: new FormControl(this.ticket?.description || '', Validators.required),
      type: new FormControl(Number(this.ticket?.type) || 0, Validators.required),
      urgency: new FormControl(Number(this.ticket?.urgency) || 0, Validators.required),
      priority: new FormControl(Number(this.ticket?.priority) || 0, Validators.required),
      status: new FormControl(Number(this.ticket?.status) || 0, Validators.required),
      estimation: new FormControl(this.ticket?.estimation || ''),
      deadline: new FormControl(hasDeadline ? moment(parseFloat(this.ticket.deadline)).toDate() : null),
      assignee: new FormControl(this.ticket?.assignee),
      testedBy: new FormControl(this.ticket?.testedBy || null),
      clientName: new FormControl(this.ticket?.clientName || ''),
      clientId: new FormControl(this.ticket?.clientId || null),
      version: new FormControl(this.ticket?.version || ''),
      contaTicketId: new FormControl(this.ticket?.contaTicketId || null),
    });
    this.form.get('deadline').valueChanges.subscribe(value => {
      if (value === null || value === '' || value === undefined) {
        this.form.get('deadline').setErrors(null);
      }
    });
  }

  saveSupportTicket() {
    console.log('form valid?', this.form.valid);
    console.log('form errors:', this.form.errors);
    console.log('form value:', this.form.value);;
    Object.keys(this.form.controls).forEach(key => {
      const ctrl = this.form.get(key);
      if (ctrl.invalid) {
        console.log(`INVALID: ${key}`, ctrl.errors, 'value:', ctrl.value);
      }
    });
  
    if(this.form.valid){
      let data = this.form.getRawValue();
      if (!data.id){
        data.createdBy = this.loggedUser.user_id;
      }
      if (data.deadline) {
        data.deadline = data.deadline.getTime();
      } else {
        data.deadline = '';
      }
      data.id ? this.updateTicket(data) : this.createTicket(data);
    } else {
      this.form.markAllAsTouched();
      if (this.form.get('title').invalid) {
        this.toastrService.show('', 'Titlul este obligatoriu!', ToastrConfigs.danger);
      }
    }
  }

  createTicket(ticketData) {
    this.supportTicketsService.createSupportTicket(ticketData).subscribe((res:any)=>{
      if(res.status){
        this.toastrService.show('','Task creat cu succes!', ToastrConfigs.success);
        this.ref.close(true);
      }else{
        this.toastrService.show('','Taskul nu a putut fi creat!', ToastrConfigs.danger);
      }
    })
  }

  updateTicket(ticketData) {
    this.supportTicketsService.updateSupportTicket(ticketData).subscribe((res:any)=>{
      if(res.status){
        this.toastrService.show('','Task actualizat cu succes!', ToastrConfigs.success);
        if (ticketData.contaTicketId) {
          const contaStatus = this.mapStatusToContaStatus(ticketData.status);
          if (contaStatus) {
              this.worksheetService.updateTicket({
                  id: ticketData.contaTicketId,
                  status: contaStatus
              }).subscribe();
          }
      }
        this.ref.close(true);
      }else{
        this.toastrService.show('','Taskul nu a putut fi actualizat!', ToastrConfigs.danger);
      }
    })
  }

  onClientSelected(client: any) {
    if (!client) {
      this.selectedClient = null;
      this.form.get('clientName').setValue('');
      this.form.get('clientId').setValue(null);
      return;
    }
    const found = this.clients.find(c => c.id === client || c.id === client?.id);
    this.selectedClient = found?.id || null;
    this.form.get('clientName').setValue(found?.name || '');
    this.form.get('clientId').setValue(found?.id || null);
  }
  dismiss() {
    this.ref.close(false);
  }

  private mapStatusToContaStatus(supportStatus: number): string | null {
    const mapping = {
        0: 'open',     
        1: 'solving',   
        2: 'sent',     
        3: 'closed',    
    };
    return mapping[supportStatus] ?? null;
}
}
